import React from "react";
import ImageFilter from "react-image-filter";
import { Canvg } from "canvg";                 // updated import

import PhotoControl from "./PhotoControl";
import { filters } from "./filter-types";

import "./PhotoPreview.css";

const PhotoPreview = (props) => {
    const errorOccured = props.petUpdateError instanceof Object ? true : false;
    const {
        petDetails,
        image,
        onChangePhoto,
        stepper,
        onUpload,
        filter,
        showLoader,
    } = props;

    const goToCrop = () => {
        stepper.goToStep(0);
    };

    const goToFilter = () => {
        stepper.goToStep(1);
    };

    // Convert the rendered SVG (from <ImageFilter/>) into a PNG data URL
    const svgToBitMapURI = async () => {
        const svg = document.querySelector("#preview-image > svg");
        if (!svg) {
            throw new Error("Preview SVG was not found in the DOM");
        }

        // Serialize the current SVG
        const svgData = new XMLSerializer().serializeToString(svg);

        // Ensure canvas exists and size matches the SVG
        const canvas = document.getElementById("preview-canvas");
        if (!canvas) throw new Error("Preview canvas not found");

        // Try to pick size from svg width/height or viewBox; fallback to 200x200
        const widthAttr = parseFloat(svg.getAttribute("width")) || 0;
        const heightAttr = parseFloat(svg.getAttribute("height")) || 0;

        let width = widthAttr;
        let height = heightAttr;

        if ((!width || !height) && svg.hasAttribute("viewBox")) {
            const [, , w, h] = svg.getAttribute("viewBox").split(" ").map(Number);
            width = width || w || 200;
            height = height || h || 200;
        }

        canvas.width = width || 200;
        canvas.height = height || 200;

        const ctx = canvas.getContext("2d");

        // Render SVG onto canvas with Canvg v3+
        const v = await Canvg.fromString(ctx, svgData, {
            useCORS: true, // important if your SVG contains external images with proper CORS headers
        });

        // Render one frame (no animations)
        await v.render();

        // Return PNG data URL
        return canvas.toDataURL("image/png");
    };

    const onUploadPhoto = async () => {
        try {
            showLoader();
            const pngDataUrl = await svgToBitMapURI();
            onUpload(pngDataUrl);
        } catch (err) {
            console.error("Upload failed:", err);
            // optionally surface an error UI here
        }
    };

    return (
        <div className="photo-preview">
            <div className="title-container">
                <h1 className="text-center">
                    Preview {petDetails.Name}
                    {"'"}s photo
                </h1>
            </div>

            {errorOccured && (
                <div style={{ textAlign: "center" }}>
                    <p className="text-danger">{props.petUpdateError.errorMessage}</p>
                </div>
            )}

            <div className="d-flex flex-column justify-content-center grow">
                <div className="d-flex justify-content-center mb-3">
                    <ImageFilter
                        id="preview-image"
                        image={image}
                        filter={filters[filter].filter}
                        svgProps={{
                            width: 200,
                            height: 200,
                        }}
                    />
                    <canvas
                        width="200"
                        height="200"
                        style={{ display: "none" }}
                        id="preview-canvas"
                    />
                </div>
                <p className="text-center font-weight-bold">
                    Would you like to upload this photo?
                </p>
            </div>

            <PhotoControl
                upload={true}
                toCrop={goToCrop}
                toFilter={goToFilter}
                onUpload={onUploadPhoto}
                onChangePhoto={onChangePhoto}
                {...stepper}
            />
        </div>
    );
};

export default PhotoPreview;
